import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SuscriptionGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    console.log('SuscriptionGuard canActivate');
    return this.authService.getUser().pipe(
      take(1),
      map(user => {
        console.log('SuscriptionGuard user', user);
        if (!user || !user.is_suscribed) {
          return this.router.createUrlTree(['/suscribirse']);
        }
        return true;
      })
    );
  }
}
